import React from "react";

const STYLES = {
  blue: {
    gradient: "from-sky-600 to-blue-700",
    icon: "bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
  },
  indigo: {
    gradient: "from-indigo-600 to-blue-800",
    icon: "bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-200",
  },
  green: {
    gradient: "from-emerald-600 to-green-700",
    icon: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
  },
  amber: {
    gradient: "from-amber-500 to-orange-600",
    icon: "bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200",
  },
  red: {
    gradient: "from-red-600 to-rose-700",
    icon: "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-200",
  },
  slate: {
    gradient: "from-slate-700 to-slate-900",
    icon: "bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white/70",
  },
};

function AdminStatCard({
  icon: Icon,
  label,
  value,
  description,
  tone = "blue",
  details = [],
}) {
  const style = STYLES[tone] || STYLES.blue;

  return (
    <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className={`h-2 bg-gradient-to-r ${style.gradient}`} />

      <div className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
              {label}
            </p>

            <p className="mt-3 font-titre text-4xl font-bold text-slate-950 dark:text-white">
              {value}
            </p>
          </div>

          {Icon && (
            <div
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${style.icon}`}
            >
              <Icon />
            </div>
          )}
        </div>

        {details.length > 0 && (
          <div className="mt-4 flex flex-wrap gap-2">
            {details.map((detail) => (
              <span
                key={detail.label}
                className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600 dark:bg-white/10 dark:text-white/60"
              >
                {detail.label} : {detail.value}
              </span>
            ))}
          </div>
        )}

        {description && (
          <p className="mt-4 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
            {description}
          </p>
        )}
      </div>
    </article>
  );
}

export default AdminStatCard;